import React from 'react';
import { connect } from 'react-redux';
import AlertRow from './AlertRow';

const AlertsTable = ({ alerts, actionsByAlert }) => (
  <>
    {alerts.map((alert) => (
      <AlertRow key={alert.id} alert={alert} actions={actionsByAlert[alert.id] ?? []} />
    ))}
  </>
);

export default connect(
  ({
    entities: {
      dataAlerts: { alerts, actionsByAlert },
    },
  }) => ({ alerts, actionsByAlert })
)(AlertsTable);
